import { alpha } from "@mui/material/styles";
import { buttonClasses } from "@mui/material/Button";
// components
import { Icon } from "@iconify/react";
import React from "react";
import { Calendar2 } from "iconsax-react";
// ----------------------------------------------------------------------
const dateList = [
    "DatePicker",
    "DateTimePicker",
    "StaticDatePicker",
    "DesktopDatePicker",
    "DesktopDateTimePicker",
    //
    "MobileDatePicker",
    "MobileDateTimePicker",
];
const timeList = [
    "TimePicker",
    "MobileTimePicker",
    "StaticTimePicker",
    "DesktopTimePicker",
];
const switchIcon = () => React.createElement(Icon, { icon: "eva:chevron-down-fill", width: 24 });
const leftIcon = () => React.createElement(Icon, { icon: "eva:arrow-ios-back-fill", width: 24 });
const rightIcon = () => React.createElement(Icon, { icon: "eva:arrow-ios-forward-fill", width: 24 });
const calendarIcon = () => React.createElement(Calendar2, { size: 20, color: "#00244D" });
const clockIcon = () => React.createElement(Icon, { icon: "solar:clock-circle-outline", width: 24 });
const desktopTypes = dateList.reduce((result, currentValue) => {
    result[`Mui${currentValue}`] = {
        defaultProps: {
            slots: {
                openPickerIcon: calendarIcon,
                leftArrowIcon: leftIcon,
                rightArrowIcon: rightIcon,
                switchViewIcon: switchIcon,
            },
        },
    };
    return result;
}, {});
const timeTypes = timeList.reduce((result, currentValue) => {
    result[`Mui${currentValue}`] = {
        defaultProps: {
            slots: {
                openPickerIcon: clockIcon,
                rightArrowIcon: rightIcon,
                switchViewIcon: switchIcon,
            },
        },
    };
    return result;
}, {});
export function datePicker(theme) {
    return Object.assign(Object.assign({ 
        // Since x-date-pickers v8 the field renders its own input components
        // (MuiPickersOutlinedInput / MuiPickersInputBase) instead of MuiOutlinedInput,
        // so the text-field overrides no longer reach it. Mirror them here.
        MuiPickersOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: "8px",
                    "&.Mui-focused .MuiPickersOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.text.secondary,
                    },
                    "&.Mui-error .MuiPickersOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.error.main,
                    },
                    "&.Mui-disabled .MuiPickersOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.action.disabledBackground,
                    },
                },
                notchedOutline: {
                    borderColor: alpha(theme.palette.grey[500], 0.2),
                    transition: theme.transitions.create(["border-color"], {
                        duration: theme.transitions.duration.shortest,
                    }),
                },
            },
        }, MuiPickersInputBase: {
            styleOverrides: {
                sectionsContainer: Object.assign({}, theme.typography.body2),
                root: {
                    "&.Mui-disabled svg": {
                        color: theme.palette.text.disabled,
                    },
                },
            },
        }, MuiPickersLayout: {
            styleOverrides: {
                root: {
                    "& .MuiPickersLayout-contentWrapper": {
                        paddingBottom: theme.spacing(1.5),
                    },
                    "& .MuiPickersLayout-actionBar": {
                        [`& .${buttonClasses.root}:last-of-type`]: {
                            backgroundColor: theme.palette.text.primary,
                            color: theme.palette.mode === "light"
                                ? theme.palette.common.white
                                : theme.palette.grey[800],
                        },
                    },
                },
            },
        } }, desktopTypes), timeTypes);
}
